import React from 'react';
import '../../stylesheets/hotel-content-settings.scss';
import URLSection from './settings/URLSection';
import useTranslate from '../../../../customHooks/useTranslate';
import { useZitoneoSettings } from '../../contexts/ZitoneoContentContext';
import StatusSection from './settings/StatusSection';
import MembershipSection from './settings/MembershipSection';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import Card from '../../../../muiComponents/Card';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import SettingsSidebar from './settings/SettingsSidebar';
import FaviconSection from './settings/FaviconSection';
import LogoSection from './settings/LogoSection';

const SettingsView = () => {
    const translate = useTranslate();
    const { HotelName } = useZitoneoSettings();
    const { isLoading } = useZitoneoUI();
    return (
        <div className='hotel-content-settings__wrapper'>
            <div className='hotel-content-settings'>
                <div className='hotel-content-settings__container'>
                    <div className='hotel-content-settings__titles_container'>
                        <h3 className='hotel-content-settings__overtitle'>{`${HotelName}`}</h3>
                        <h2 className='hotel-content-settings__title'>
                            {translate('settings')}
                        </h2>
                    </div>
                    {isLoading ? (
                        <Card className='padding20'>
                            <LoadingPlaceholder width='100%' height='600px' />
                        </Card>
                    ) : (
                        <>
                            <MembershipSection />
                            <StatusSection />
                            <FaviconSection />
                            <LogoSection />
                            <URLSection />
                        </>
                    )}
                </div>
            </div>
            <SettingsSidebar />
        </div>
    );
};

export default SettingsView;
